import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {addClient} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import ClientsForm from './ClientsForm';
import PropTypes from 'prop-types';

class ClientsCreateModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      errors: []
    };

    this.saveClient = this.saveClient.bind(this);
    this.clientsForm = React.createRef();
  }

  saveClient(e, data){
    e.preventDefault();
    this.setState({saving: true, errors: []});

    this.props.addClient({
      data: data
    }).then(() => {
      this.setState({
        saving: false
      });
      this.props.toggle();
    })
      .catch((e) => {
        if(e.response.data.form.errors){
          this.setState({
            saving: false,
            errors: e.response.data.form.errors,
          });
        }
      });
  }

  render() {
    const { saving, errors } = this.state;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle} tag="h2"><FormattedMessage id="clientsButtonCreate.modalHeader" /></ModalHeader>
        <hr className="my-0" />
        <ModalBody>
          <ClientsForm errors={errors} onSubmit={this.saveClient} ref={this.clientsForm}/>
        </ModalBody>
        <ModalFooter>
          <div className="direction-group d-flex justify-content-end">
            <div className="direction-right">
              <FormattedMessage id="_.button.save">{
                (message) => <LaddaButton
                  className="btn btn-primary btn-ladda mb-0 ml-3"
                  loading={saving}
                  data-style={ZOOM_OUT}
                  onClick={e => this.saveClient(e, this.clientsForm.current.state.data)}
                >
                  {message}
                </LaddaButton>
              }</FormattedMessage>
              <FormattedMessage id="_.button.cancel">{
                (message) =>
                  <Button color="secondary" className="mb-0 ml-3" onClick={this.props.toggle}>{message}</Button>
              }</FormattedMessage>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

ClientsCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default connect(null, { addClient }, null, {forwardRef: true})(ClientsCreateModal);